/**
 * @generated SignedSource<<12b3b0c6a483e4493c044a7e34ea9a91>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NavLogoHamburger_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useNotificationsConfig_viewer">;
  readonly " $fragmentType": "NavLogoHamburger_viewer";
};
export type NavLogoHamburger_viewer$key = {
  readonly " $data"?: NavLogoHamburger_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"NavLogoHamburger_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NavLogoHamburger_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useNotificationsConfig_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "2f8cc16bd3b5d06f2442c90c751ac0ec";

export default node;
